import { render, staticRenderFns } from "./commPromise.vue?vue&type=template&id=9773f0bc&scoped=true&"
import script from "./commPromise.vue?vue&type=script&lang=js&"
export * from "./commPromise.vue?vue&type=script&lang=js&"
import style0 from "./commPromise.vue?vue&type=style&index=0&id=9773f0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9773f0bc",
  null
  
)

export default component.exports